module.exports = (fox) => {
	const AutoLoginService = require('../../../components/auto-login')(fox);

	fox.registerWidget('Avs_MC', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				widgets: {
					avsPermissionApi: {
						widget: 'Api',
						method: 'ageVerification.user.isRequired'
					},
					avsVerifyDataApi: {
						widget: 'Api',
						method: 'ageVerification.user.pendingRequest'
					},
					avsUpsellApi: {
						widget: 'Api',
						method: 'ageVerification.user.upsell'
					},
					avsPopup: {
						widget: 'PopupWidget',
						preventHideOnShadowClick: true,
						title: '',
						dialog: {
							width: '580px',
							'!dialogClass': 'dlg-amc dark-overlay avs-popup'
						},
						widgets: {
							cbContent: {
								widget: 'Widget',
								autoRender: false,
								manualRender: true,
								template: 'popup_cb_avs_yoti'
							},
							verifyContent: {
								widget: 'Widget',
								autoRender: false,
								manualRender: true,
								template: 'popup_verify_avs_yoti'
							},
							avsForm: {
								widget: 'DomForm',
								formPath: '@parent #cbContent',
								formSelector: '#user-data',
								elements: {
									email: {
										validators: [
											{validator: "mandatory"},
											{validator: "regexp", options: {type: 'email'}, message: "Wrong email format"},
										],
									},
									username: {
										element: '[name=username]',
										validators: [{validator: "mandatory"}],
									},
								}
							},
						}
					},
				},
				handleDom: {
					startAvs: {
						targetWidget: '#avsPopup #cbContent',
						target: '.start-avs',
						callback: 'startAvs'
					},
					focus: {
						targetWidget: '#avsPopup #cbContent',
						target: 'input',
						event: 'focus',
						callback: '_handleFocus'
					},
					closeOnLoginPage: {
						targetWidget: '#avsPopup #cbContent',
						target: '.login-link',
						callback: () => {
							this.popup.hide();
							this.destroy();
						}
					},
					verifyAvs: {
						targetWidget: '#avsPopup #verifyContent',
						target: '.verify-avs',
						callback: 'verifyAvs'
					},
				},
				handleWom: {
					formsInvalidate: {
						widget: '#avsPopup #avsForm',
						event: ['form_not_valid', 'form_valid'],
						callback: '_handleFormValidation'
					},
					formAddedToDom: {
						widget: '#avsPopup #cbContent',
						event: 'addedToDom',
						callback: () => {
							const el = this.popup.dom1('[name="email"]');
							el.focus();
						}
					},
					gdprPopupClosed: {
						widget: '@root',
						event: 'gdprPopupClosed',
						callback: 'showAvsPopup'
					}
				},
			});
		
			this.callParent('configure', arguments);
		},

		init() {
			this.autoLoginService = new AutoLoginService(this);

			this.callParent("init", arguments);
		},

		running() {
			this.callParent('running', arguments);

			this.popup = this.wom1('#avsPopup');
			this.form = this.popup.wom1('#avsForm');
			this.avsPermissions = {};

			this.showAvsPopup();
		},

		deactivate() {
			this.callParent('deactivate', arguments);

			this.popup.hide();
		},

		getAvsPermissions() {
			const api = this.wom1('#avsPermissionApi');
			return api.psend().then((data) => {
				const resp = data.params.answer.response;
				this.avsPermissions = {
					avsRequired: resp.isAgeVerificationRequired || false,
					verifyRequired: resp.hasPendingRequest || false,
				};
				return true;
			});
		},

		getVerificationData() {
			const api = this.wom1('#avsVerifyDataApi');
			return api.psend().then((data) => {
				const resp = data.params.answer.response;
				this.verifyUrl = resp.verificationLink;
				return true;
			});
		},
		
		showAvsPopup(verifyStepFinished) {
			if (location.pathname === '/login' || location.pathname.indexOf('password-recovery') === 1) {
				return;
			}

			this.stopTimerCheck();

			this.getAvsPermissions().then(() => {
				if (this.avsPermissions.avsRequired && !this.avsPermissions.verifyRequired) {
					this.popup.wom1('#cbContent').render();
					this.popup.show();
				} else if (fox.getEnv('member') && this.avsPermissions.verifyRequired && !fox.getEnv('getConsents')) {
					this.getVerificationData().then(() => {
						if (this.verifyUrl !== undefined) {
							this.popup.wom1('#verifyContent').render();
							this.popup.show();
						}
					});
				} else {
					this.popup.hide();
					if (verifyStepFinished === true) {
						window.location.reload();
					}
				}
			});
		},

		showSuccessPopup() {
			this.showAvsPopup();
		},

		cbPopupSuccessHandler() {
			if (this.verifyUrl) {
				this.showAvsPopup(true);
			}
		},

		startAvs() {
			if ($(this.popup.dom1('.start-avs')).hasClass('disabled')) {
				return false;
			}

			this.form.submit().then(values => {
				if (values === false) {
					return;
				}

				this.startTimerCheck();				

				const { token } = this.autoLoginService.injectToken({}, new Date().getTime().toString());

				values.token = token;

				this.showCbPopup(this.wom1('#avsUpsellApi').psend(values), token);
				
			}).catch(e => {
				console.log(e);
			});
		},

		showCbPopup(resolver, token) {
			var autoLoginService = this.autoLoginService;
			var cbPopup = this.wom1('#cbPaymentPopup');
			
			if (!cbPopup) {
				cbPopup = this.embedWidget('cbPaymentPopup', 'CBPaymentPopup', {
					matchTokenFunction: function (token) {
						return autoLoginService ? autoLoginService.matchToken(token) : false;
					}
				});

				cbPopup.run();
			}

			this._togglePreloader(true);

			resolver.then((resp) => {
				resp = resp.params.answer.response;
				if (!resp || typeof resp.submit_url == "undefined") {
					return false;
				}

				const url =
					resp.submit_url + '?' + fox.toQueryString(resp.added_fields);

				cbPopup.show(Promise.resolve({ url }));
				
				if (!fox.getEnv('member')) {
					this.autoLoginService.shouldAuthorize(token);
				}
			})
			.catch((error) => {
				this.stopTimerCheck();

				if (!fox.getEnv('member')) {
					let	code = error.params.answer.code,
						msg = error.params.answer.reason || '';

					if (code === 12) {
						msg = msg + '. <a href="/login" class="link">Log in here</a>.'
					}

					this.toggleError('email', true, msg);
				}

				if (code === 31) {
					msg = '';
					this.startTimerCheck();
				}
			});
		},

		verifyAvs() {
			var cbPopup = this.wom1('#cbPaymentPopup');
			
			if (!cbPopup) {
				cbPopup = this.embedWidget('cbPaymentPopup', 'CBPaymentPopup');
				cbPopup.run();
			}

			const url = this.verifyUrl;

			cbPopup.show(Promise.resolve({ url }));
		},

		toggleError(name, state, message) {
			var el = this.popup.dom1('[name="' + name + '"]'),
				msgEl = fox.dom.selectFirst('.error-msg', el.parentNode),
				msg = message || el.validationMessage || '';

			fox.dom[state ? 'addClass' : 'removeClass']('error', el.parentNode);

			if (!fox.isEmpty(msg)) {
				msgEl.innerHTML = msg;
			}

			if (!state) {
				msgEl.innerHTML = '';
			}
		},

		_handleFormValidation: function (info, w) {
			fox.each(info, (item) => {
				this.toggleError(item.field, !item.result)
			});
		},

		_handleFocus(el) {
			this.toggleError(el.name, false);
		},

		_togglePreloader(state) {
			var btn = this.popup.dom1('.start-avs');
			fox.dom[state ? 'addClass' : 'removeClass']('spin', btn);
		},

		_toggleDisabledState(state) {
			var btn = this.popup.dom1('.start-avs');
			fox.dom[state ? 'addClass' : 'removeClass']('disabled', btn);
		},

		startTimerCheck: function () {
			this._toggleDisabledState(true);

			this.timer = window.setInterval(() => {
				this._toggleDisabledState(false);
				this._togglePreloader(false);
			}, 3000 );
		},

		stopTimerCheck: function () {
			if (!this.timer) {
				return;
			}

			this._toggleDisabledState(false);
			this._togglePreloader(false);

			window.clearInterval(this.timer);
		},

	}, 'Controller');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/avs-yoti/widget/avsYoti.es.js